import React from 'react';
import { Clock, MapPin, CarFront, CalendarDays } from 'lucide-react';
import { OPENING_HOURS, BUSINESS_INFO } from '../../utils/constants';

const OpeningHours = () => {
  return (
    <section className="trust-strip">
      <div className="container">
        <div className="trust-strip-grid">
          <div className="trust-item">
            <div className="trust-icon">
              <CalendarDays size={20} />
            </div>
            <div>
              <div className="trust-item-title">{OPENING_HOURS.weekday.days}</div>
              <div className="trust-item-sub">{OPENING_HOURS.weekday.hours}</div>
            </div>
          </div>

          <div className="trust-item">
            <div className="trust-icon">
              <Clock size={20} />
            </div>
            <div>
              <div className="trust-item-title">{OPENING_HOURS.weekend.days}</div>
              <div className="trust-item-sub">{OPENING_HOURS.weekend.hours}</div>
            </div>
          </div>

          <div className="trust-item">
            <div className="trust-icon">
              <CarFront size={20} />
            </div>
            <div>
              <div className="trust-item-title">Mobile Service</div>
              <div className="trust-item-sub">We come to you</div>
            </div>
          </div>

          <div className="trust-item">
            <div className="trust-icon">
              <MapPin size={20} />
            </div>
            <div>
              <div className="trust-item-title">Service Area</div>
              <div className="trust-item-sub">Greater Sheffield & Surrounding</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;